import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Country } from '../../../models/country.model';
import { CountryService } from '../../../services/country/country.service';
import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.css'],
  providers: []
})
export class CountryComponent implements OnInit {

  selectedCountry: Country = new Country();
  showDetail = false;
  newDataAvailable = false;
  title: string;
  countries: Country[] = [];
  includeDeleted = false;
  modalTitle = '';
  paginationType = KontableComponent.ServerPagination;
  labels = {}

  constructor(
    public srvCountry: CountryService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.translate.get([
      'countryList.add_title',
      'countryList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['countryList.add_title'];
      this.labels['edit_title'] = res['countryList.edit_title'];
    });
  }

  countryAdded(country: Country) {
    this.srvCountry.post(country).subscribe(() => {
      this.showDetail = false;
      this.newDataAvailable = true;
    });
  }

  countryUpdated(country: Country) {
    this.srvCountry.put({
      id: country.id,
      iso_code: country.iso_code,
      name: country.name,
      language_id: country.language_id,
      currency_id: country.currency_id,
    }, false).subscribe(() => {
        this.showDetail = false;
        this.newDataAvailable = true;
      });
  }

  removeCountry(country: Country) {
    this.srvCountry.delete(country).subscribe(() => {
        this.newDataAvailable = true;
    });
  }

  recoverCountry(country: Country) {
    this.srvCountry.recover(country).subscribe(() => {
      this.newDataAvailable = true;
    });
  }

  showEditDialog(row: Country) {
    this.modalTitle = row == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.selectedCountry = row == null ? new Country() : row;
    this.showDetail = true;
  }

  onDialogHide() {
    this.modalTitle = '';
    this.selectedCountry = null;
  }

  includeDeletedChange(evt) {
    this.includeDeleted = evt;
    this.newDataAvailable = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/country/country.component.ts